export function coralCommentsCountUpdate () {
    let currentEdtn = document.querySelector('body').dataset.edtn;
    let isCpUser = document.cookie.includes('_cpauthhint=1');
    let functionalCookieIsEnabled = window.msntConsent.isSocialsAllowed();
    const coralCommentsEditions = ['us', 'ev_us', 'ra_us', 'ev_br'];

    if (!coralCommentsEditions.includes(currentEdtn)) {
      return;
    }

    if (window.msntConsent.params === null) {
      return setTimeout(coralCommentsCountUpdate, 100);
    }

    if (currentEdtn === 'ra_us') {
      $('.coral-script').remove();
      window.CoralCount = undefined;
      const host = window.location.host;
      let coralEnviroment;
      if (host === 'www.rideapart.com') {
        coralEnviroment = 'coral';
      } else if (host === 'ra-s.motor1.com') {
        coralEnviroment = 's-coral';
      } else if (host === 'ra-q.motor1.com') {
        coralEnviroment = 'q-coral';
      } else {
        coralEnviroment = 'coral';
      }
      let script;
      if (isCpUser && functionalCookieIsEnabled) {
        script = `<script defer class="coral-script" src="https://${coralEnviroment}.rideapart.com/assets/js/count.js"></script>`;
      }
      if (!isCpUser) {
        script = `<script defer class="coral-script" src="https://${coralEnviroment}.rideapart.com/assets/js/count.js"></script>`;
      }
      $("head").append(script);
    }
    if(currentEdtn === 'fr') {
      $('.coral-script').remove();
      window.CoralCount = undefined;
      let script;
      if (isCpUser && functionalCookieIsEnabled) {
        script = '<script defer class="coral-script" src="https://fr-coral.motor1.com/assets/js/count.js"></script>';
      } 
      if (!isCpUser) {
        script = '<script defer class="coral-script" src="https://fr-coral.motor1.com/assets/js/count.js"></script>';
      }

      $("head").append(script);
    }
    if(currentEdtn === 'us') {
      $('.coral-script').remove();
      window.CoralCount = undefined;
      let script;
      if (isCpUser && functionalCookieIsEnabled) {
        script = '<script defer class="coral-script" src="https://www-coral.motor1.com/assets/js/count.js"></script>';
      } 
      if (!isCpUser) {
        script = '<script defer class="coral-script" src="https://www-coral.motor1.com/assets/js/count.js"></script>';
      }
      
      $("head").append(script);
    }
    if(currentEdtn === 'ev_us') {
      $('.coral-script').remove();
      window.CoralCount = undefined;
      const script = '<script defer class="coral-script" src="https://us-coral.insideevs.com/assets/js/count.js"></script>';
      $("head").append(script);
    }
    if(currentEdtn === 'ev_br') {
      $('.coral-script').remove();
      window.CoralCount = undefined;
      const script = '<script defer class="coral-script" src="https://br-coral.insideevs.com/assets/js/count.js"></script>';
      $("head").append(script);
    }
    return;
  }